// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/rank/players_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@assets/rank/player_profile_bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.highlights-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    margin-right: 28px;
}

.award-player-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    position: relative;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 100% 100%;
    min-height: 118px;
    min-width: 148px;
    margin-bottom: 4px;
}

/* .award-player-container img {
    position: absolute;
    width: 64px;
    height: 64px;
    top: -32px;
}  */

.award-player-avatar-container { 
    position: absolute;
    width: 64px;
    height: 64px;
    top: -32px; 
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}); 
    background-size: 100% 100%; 
    display: flex; 
    justify-content: center; 
    align-items: center;
} 

.award-player-avatar-container > img { 
    width: 60px; 
    height: 60px; 
    border-radius: 6px;
}

.award-player-name {
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
    position: absolute;
    top: 42px;
    text-transform: uppercase;
    max-width: 130px;
    overflow: hidden;
    white-space: nowrap;
}

.award-player-title {
    font-size: 12px;
    font-weight: 500;
    color: #ffa600;
    position: absolute;
    top: 56px;
    text-transform: uppercase;
    max-width: 120px;
    overflow: hidden;
    white-space: nowrap;
}

.award-player-desc {
    font-size: 10px;
    color: #FFFFFF;
    position: absolute;
    bottom: 16px; 
}

.award-player-container.clickable {
    cursor: pointer;
    transition: transform 0.2s ease, filter 0.2s ease;
}

.award-player-container.clickable:hover {
    transform: scale(1.05);
    filter: brightness(1.2);
}`, "",{"version":3,"sources":["webpack://./src/components/awardedPlayer/AwardedPlayer.style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,yDAAoD;IACpD,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;;;;;IAKI;;AAEJ;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,yDAA2D;IAC3D,0BAA0B;IAC1B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B","sourcesContent":[".highlights-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 4px;\n    margin-right: 28px;\n}\n\n.award-player-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    position: relative;\n    background-image: url('@assets/rank/players_bg.png');\n    background-size: 100% 100%;\n    min-height: 118px;\n    min-width: 148px;\n    margin-bottom: 4px;\n}\n\n/* .award-player-container img {\n    position: absolute;\n    width: 64px;\n    height: 64px;\n    top: -32px;\n}  */\n\n.award-player-avatar-container { \n    position: absolute;\n    width: 64px;\n    height: 64px;\n    top: -32px; \n    background-image: url('@assets/rank/player_profile_bg.png'); \n    background-size: 100% 100%; \n    display: flex; \n    justify-content: center; \n    align-items: center;\n} \n\n.award-player-avatar-container > img { \n    width: 60px; \n    height: 60px; \n    border-radius: 6px;\n}\n\n.award-player-name {\n    font-size: 12px;\n    font-weight: 500;\n    color: #FFFFFF;\n    position: absolute;\n    top: 42px;\n    text-transform: uppercase;\n    max-width: 130px;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.award-player-title {\n    font-size: 12px;\n    font-weight: 500;\n    color: #ffa600;\n    position: absolute;\n    top: 56px;\n    text-transform: uppercase;\n    max-width: 120px;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.award-player-desc {\n    font-size: 10px;\n    color: #FFFFFF;\n    position: absolute;\n    bottom: 16px; \n}\n\n.award-player-container.clickable {\n    cursor: pointer;\n    transition: transform 0.2s ease, filter 0.2s ease;\n}\n\n.award-player-container.clickable:hover {\n    transform: scale(1.05);\n    filter: brightness(1.2);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
